$(->
  # ADMIN > HEALTH GRADE KEYS
  
  $('form.health_grade_key input.label-green').on 'change', ->
    group = $(this).closest('fieldset')
    if $(group).find('input.label-yellow').val() == ''
      $(group).find('input.label-red').val($(this).val())

  $('form.health_grade_key input.label-yellow').on 'change', ->
    group = $(this).closest('fieldset')
    if $(this).val() == ''
      $(group).find('input.label-red').val($(group).find('input.label-green').val())
    else
      $(group).find('input.label-red').val($(this).val())
)
